import { render, staticRenderFns } from "./CheckedSvg.vue?vue&type=template&id=b28439e2&"
import script from "./CheckedSvg.vue?vue&type=script&lang=js&"
export * from "./CheckedSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports